<script>
import { mapGetters } from "vuex";
import L from "leaflet";
import { Icon } from "leaflet";
import { LMap, LTileLayer, LCircle } from "vue2-leaflet";
import LDrawToolbar from "vue2-leaflet-draw-toolbar";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";
import "leaflet/dist/leaflet.css";
// import 'leaflet-draw/dist/leaflet.draw.css';
// import 'leaflet-draw';

export default {
  props: ["timezone", "isEdit"],
  components: {
    LMap,
    LTileLayer,
    LDrawToolbar,
    VGeosearch,
    LCircle,
    // LControl,
  },

  data() {
    return {
      editLabel: false,
      radius: null,
      coordinates: null,
      locationName: null,
      geosearchOptions: {
        provider: new OpenStreetMapProvider(),
      },

      url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 2,
      center: [37.65599248067672, -94.7409966716293],
      circle: {
        center: [null, null],
        radius: null,
        color: "red",
      },
      bounds: null,
      drawOptions: null,
      drawnLayers: [],
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    ...mapGetters("sites", ["getRadius", "getLong", "getLat", "getZoom"]),
  },

  mounted() {
    this.$store.commit("sites/setHideSiteModal", true);
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });

    const map = this.$refs.map.mapObject;
    setTimeout(() => {
      map.invalidateSize();
    }, 200);
    const drawControl = new L.Control.Draw({
      edit: {
        featureGroup: new L.FeatureGroup(),
      },
    });
    map.addControl(drawControl);

    // Listen for the draw:created event
    map.on(L.Draw.Event.CREATED, this.onDrawCreated);
    map.on(L.Draw.Event.EDITED, this.onDrawEdited);
    map.on(L.Draw.Event.DELETED, this.onDrawDeleted);

    if (this.getRadius) {
      // if location set => get location scope
      map.setView([this.getLat, this.getLong], this.getZoom ?? 6);
      this.center = [this.getLat, this.getLong];
      this.circle.center = [this.getLat, this.getLong];
      this.circle.radius = this.getRadius;
      this.editLabel = true;
    } else {
      // if no location set yet => get browser scope or timezone
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var latitude = position.coords.latitude;
            var longitude = position.coords.longitude;

            // Center the map on the user's location
            map.setView([latitude, longitude], 60);
          },
          (error) => {
            // location access denied
            console.error("Error getting user location:", error);
            if (this.timezone) {
              // if timezone selected => get timezone scope
              this.getCoordinatesByTimezone(this.timezone).then(
                (coordinates) => {
                  if (coordinates) {
                    console.log("Coordinates:", coordinates);
                    var latitude = coordinates.latitude;
                    var longitude = coordinates.longitude;
                    map.setView([latitude, longitude], 6);
                  } else {
                    console.log("Coordinates not found.");
                  }
                }
              );
            }
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    }
  },
  methods: {
    async saveCoordinates() {
      await this.$store.commit("sites/setRadius", this.radius);
      await this.$store.commit("sites/setLat", this.coordinates[0]);
      await this.$store.commit("sites/setLong", this.coordinates[1]);
      await this.$store.commit("sites/setLocationName", this.locationName);
      await this.$store.commit("sites/setZoom", this.zoom);
      this.$bvModal.hide("addLocation");
    },
    reverseGeocode(lat, lng) {
      return new Promise((resolve, reject) => {
        fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("data", data);
            if (data.error) {
              this.$toast.error(
                "Unable to get the location, try with different coordinates.",
                {
                  position: "top-right",
                }
              );
            }
            const locationName = data.name ? data.name : data.display_name;
            resolve(locationName);
            this.locationName = locationName;
          })
          .catch((error) => {
            reject(error);
            this.$toast.error("Server is down, please try again later.", {
              position: "top-right",
            });
          });
      });
    },
    async getCoordinatesByTimezone(timezone) {
      try {
        const encodedTimezone = encodeURIComponent(timezone);

        const response = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodedTimezone}`
        );
        const data = await response.json();

        if (data && data.length > 0) {
          const { lat, lon } = data[0];
          return { latitude: parseFloat(lat), longitude: parseFloat(lon) };
        } else {
          return null;
        }
      } catch (error) {
        console.error("Error:", error);
        return null;
      }
    },
    zoomUpdated(zoom) {
      // console.log('zoom')
      this.zoom = zoom;
    },
    centerUpdated(center) {
      // console.log('centerUpdated')
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
      // console.log('bounds', this.bounds);
    },
    onDrawDeleted() {
      this.radius = null;
      this.coordinates = null;
      this.locationName = "";
    },
    onDrawCreated(event) {
      console.log("onDrawCreated", event);
      this.locationName = "";
      const layer = event.layer;
      const type = event.layerType;
      let coordinates = [];
      let radiusM = null;

      // // Get coordinates based on the type of shape drawn
      // if (type === 'rectangle') {
      //   const bounds = layer.getBounds();
      //   coordinates = [
      //     [bounds.getNorth(), bounds.getWest()],
      //     [bounds.getSouth(), bounds.getEast()]
      //   ];
      // } else if (type === 'polygon' || type === 'polyline') {
      //   coordinates = layer.getLatlngs().map(latlng => [latlng.lat, latlng.lng]);
      if (type === "circle") {
        const center = layer.getLatLng();
        radiusM = layer.getRadius();
        coordinates = [center.lat, center.lng];
      }

      this.radius = radiusM;
      this.coordinates = coordinates;
      this.reverseGeocode(this.coordinates[0], this.coordinates[1]);
    },
    onDrawEdited(event) {
      this.locationName = "";
      console.log("onDrawEdited", event);
      const layer = event.layers.getLayers()[0];
      let coordinates = [];
      let radiusM = null;

      // // Get coordinates based on the type of shape drawn
      // if (type === 'rectangle') {
      //   const bounds = layer.getBounds();
      //   coordinates = [
      //     [bounds.getNorth(), bounds.getWest()],
      //     [bounds.getSouth(), bounds.getEast()]
      //   ];
      // } else if (type === 'polygon' || type === 'polyline') {
      //   coordinates = layer.getLatlngs().map(latlng => [latlng.lat, latlng.lng]);
      // if (type === 'circle') {
      const center = layer.getLatLng();
      radiusM = layer.getRadius();
      coordinates = [center.lat, center.lng];
      // }

      this.radius = radiusM;
      this.coordinates = coordinates;
      this.reverseGeocode(this.coordinates[0], this.coordinates[1]);
    },
  },
  destroyed() {
    this.$store.commit("sites/setHideSiteModal", false);
  },
};
</script>

<template>
  <div class="site-details-wrapper">
    <div class="d-flex align-items-center justify-content-end modal-title-head">
      <div class="title-head">
        <p class="location-title-head">
          {{ editLabel ? $t('sitesAndDevices.editLocation') : $t('sitesAndDevices.addLocation') }}
        </p>
      </div>
      <svg
        @click="$bvModal.hide('addLocation')"
        class="CloseLocation"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>

    <!-- <div :ref="mapContainer" style="width: 446px; height: 551px; border-radius: 21px; margin: auto"></div> -->

    <!-- <div style="height: 90vh; width: 90vw;">
            <l-map ref="map" style="height: 90vh; width: 90vw;" :zoom="zoom" :center="center" @update:zoom="zoomUpdated"
                @update:center="centerUpdated" @update:bounds="boundsUpdated">
                <l-tile-layer :url="url"></l-tile-layer>
                <v-geosearch :options="geosearchOptions"></v-geosearch>
                <l-draw-toolbar position="topleft"></l-draw-toolbar>
            </l-map>
            <div>zoom: {{ zoom }}, center: {{ center }}</div>
        </div> -->
    <div :class="{ circleDrawn: !!this.radius }">
      <l-map
        ref="map"
        style="height: 551px; border-radius: 21px"
        :zoom="zoom"
        :center="center"
        @update:zoom="zoomUpdated"
        @update:center="centerUpdated"
        @update:bounds="boundsUpdated"
      >
        <l-tile-layer :url="url"></l-tile-layer>
        <!-- <l-control position="topleft" :drawCircle="true" /> -->
        <!-- <l-circle-drawer :shapeStyle="shapeStyle"></l-circle-drawer> -->
        <!-- </l-control> -->
        <!-- <l-marker :lat-lng="[getLat, getLong]"></l-marker> -->
        <l-circle
          :lat-lng="circle.center"
          :radius="circle.radius"
          :color="circle.color"
        />

        <v-geosearch :options="geosearchOptions"></v-geosearch>

        <l-draw-toolbar clas="custom-draw" position="topleft"></l-draw-toolbar>
      </l-map>
    </div>

    <div class="action-btns">
      <button
        @click="saveCoordinates"
        type="button"
        class="submit-action-btn btn btn-primary add-edit"
        size="lg"
        :disabled="!radius || !coordinates || !locationName"
      >
        {{ editLabel ? $t('common.edit') : $t('common.add') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss">
.circleDrawn a.leaflet-draw-draw-circle {
  pointer-events: none !important;
  opacity: 0.6 !important;
}
.leaflet-draw-edit-edit {
  display: none !important;
}
.leaflet-popup-toolbar {
  width: 61px !important;
}

.leaflet-draw-section,
.leaflet-draw-draw-polygon,
.leaflet-draw-draw-polyline,
.leaflet-draw-draw-marker,
.leaflet-draw-draw-rectangle {
  display: none !important;
}

div#addLocation {
  div#addLocation___BV_modal_content_ {
    width: 1092px !important;
    border-radius: 26px !important;
    margin-top: 55px;
    div#addLocation___BV_modal_body_ {
      padding: 40px 24px 32px 24px !important;
      .action-btns {
        margin-top: 32px;
        button.submit-action-btn.btn.btn-primary.add-edit {
          width: 111px;
          height: 33px;
          background: #103f5e;
          border-radius: 16.5px;
          font-weight: 400;
          font-size: 16px;
          line-height: 19px;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .leaflet-container .leaflet-control-attribution {
        display: none !important;
      }
      button.submit-action-btn.btn.btn-primary.add-edit:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }

      .d-flex.align-items-center.justify-content-end.modal-title-head {
        margin-bottom: 40px;
        margin-inline-end: 16px;

        margin-inline-start: auto;
      }

      p.location-title-head {
        font-size: 16px;
        font-weight: 700;
        line-height: 20.4px;
        color: #000;
        margin-bottom: 0 !important;
        margin-inline-end: 290px;
        top: 9px;

        inset-inline-start: -20px !important;
      }
    }
  }
}
</style>
